import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";

export default function AddWordManualDialog({ open, onOpenChange }) {
  const [word, setWord] = useState("");
  const [sentence, setSentence] = useState("");
  const [error, setError] = useState("");
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => api.post("/words/manual", { word, sentence: sentence || undefined }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["words"] });
      setWord("");
      setSentence("");
      onOpenChange(false);
    },
    onError: (e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    mutation.mutate();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="add-word-manual-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Добавить слово вручную</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-md px-3 py-2" data-testid="add-word-manual-error">
              {error}
            </div>
          )}
          <Input
            autoFocus
            placeholder="Слово (например: serendipity)"
            value={word}
            onChange={(e) => setWord(e.target.value)}
            data-testid="add-word-manual-word-input"
          />
          <Textarea
            placeholder="Пример предложения (необязательно — AI сгенерирует, если оставить пустым)"
            value={sentence}
            onChange={(e) => setSentence(e.target.value)}
            data-testid="add-word-manual-sentence-input"
            rows={2}
          />
          <Button type="submit" className="w-full" disabled={mutation.isPending || !word} data-testid="add-word-manual-submit-button">
            {mutation.isPending ? <Loader2 className="w-4 h-4 animate-spin" /> : "Добавить"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
